// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"147ade8a","453":"48cb2101","796":"22dc581d"}[chunkId] + ".chunk.js";
};